module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./home-instruction.md");


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/home-instruction.md
// module id = 344
// module chunks = 5 49